

















































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import VaultInjectorMixin from "@/mixins/vaultInjectorMixin";

@Component({
  components: {
    "vault-note-item": () =>
      import("@/components/app/global/vault/vaultNoteItem.vue")
  }
})
export default class VaultNotesListing extends Mixins(VaultInjectorMixin) {
  // Props

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public showEmptyState!: boolean;

  @Prop({ default: null })
  public skeletonCount!: number;

  // Computed

  public get skeletonSize() {
    return (
      this.vaultData.assets.length ||
      (this.skeletonCount ?? (this.$store.getters["ui/isMobile"] ? 2 : 3))
    );
  }

  public get hasSkeletons() {
    const { assets, isLoading, total } = this.vaultData;
    return !assets.length && (isLoading || !total);
  }
}
